import { React, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFCheckbox, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import axiosInstance from 'src/api/axiosInstance';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';

export default function EmpRelwrknwithusNewEditForm({ relshnData, countryArr, desgRefData }) {
  const token = sessionStorage.getItem('token');
  const [stateArrMap, setStateArrMap] = useState({});
  const [cityArrMap, setCityArrMap] = useState({});
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empRelWrkn',
  });

  const handleAdd = () => {
    append({
      cntctSrno: 0,
      name: '',
      relationship: null,
      curAddCntr: null,
      curAddState: null,
      curAddCity: null,
      curAddStateAvailable: false,
      curAddCityAvailable: false,
      refdesig: null,
    });
  };

  const handleRemove = (index, id) => {
    remove(index);
    setStateArrMap((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
    setCityArrMap((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };
  const handleCountryChange = (itemId, index, selectedCountryId) => {
    axiosInstance
      .get(`/rest/state/findStates?countryId=${selectedCountryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setStateArrMap((prev) => ({ ...prev, [itemId]: res.data }));
        setValue(`empRelWrkn[${index}].curAddStateAvailable`, res.data.length > 0, {
          shouldValidate: true,
        });
      })
      .catch(() => {
        setStateArrMap((prev) => ({ ...prev, [itemId]: [] }));
        setValue(`empRelWrkn[${index}].curAddStateAvailable`, false, { shouldValidate: true });
      });
  };

  const handleStateChange = (itemId, index, selectedStateId) => {
    axiosInstance
      .get(`/rest/cities/findCities?stateId=${selectedStateId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCityArrMap((prev) => ({ ...prev, [itemId]: res.data }));
        setValue(`empRelWrkn[${index}].curAddCityAvailable`, res.data.length > 0, {
          shouldValidate: true,
        });
      })
      .catch(() => {
        setCityArrMap((prev) => ({ ...prev, [itemId]: [] }));
        setValue(`empRelWrkn[${index}].curAddCityAvailable`, false, { shouldValidate: true });
      });
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={1}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: '2fr 1fr',
        }}
        mb={3}
      >
        <Typography variant="subtitle2" sx={{ mb: '10px' }}>
          Do you have any relative already working with us ? If yes, please add their details.
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Relative
          </Button>
        </Stack>
        {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          If Yes, Please provide details...
        </Typography> */}
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 1 }}>
              Working Relative {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`empRelWrkn[${index}].cntctSrno`} />
            </Box>
            <Box
              rowGap={2}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <RHFTextField
                name={`empRelWrkn[${index}].name`}
                label={
                  <div>
                    Full Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRelWrkn[${index}].relationship`}
                  placeholder="Select relationship"
                  label={
                    <div>
                      Relationship<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={relshnData}
                  showPlusIcon
                  getOptionLabel={(option) => option?.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option?.masterId}>
                      {option?.masterName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRelWrkn[${index}].curAddCntr`}
                  placeholder="Select country"
                  label={<div>
                      Country<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>}
                  options={countryArr}
                  getOptionLabel={(option) => option.countryName}
                  onChange={(event, value) => {
                    setValue(`empRelWrkn[${index}].curAddCntr`, value, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddState`, null, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddCity`, null, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddStateAvailable`, false, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddCityAvailable`, false, { shouldValidate: true });
                    setCityArrMap((prev) => ({ ...prev, [item.id]: [] }));
                    if (value) {
                      handleCountryChange(item.id, index, value.countriesId);
                    } else {
                      setStateArrMap((prev) => ({ ...prev, [item.id]: [] }));
                    }
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.shortName}>
                      {option.countryName}
                    </li>
                  )}
                  sx={{ mb: 1 }}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRelWrkn[${index}].curAddState`}
                  placeholder="Select state"
                  label={
                    <div>
                      State
                      {(stateArrMap[item.id]?.length > 0) && (
                        <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      )}
                    </div>
                  }
                  options={stateArrMap[item.id] || []}
                  getOptionLabel={(option) => option.stateName}
                  onChange={(event, value) => {
                    setValue(`empRelWrkn[${index}].curAddState`, value, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddCity`, null, { shouldValidate: true });
                    setValue(`empRelWrkn[${index}].curAddCityAvailable`, false, { shouldValidate: true });
                    if (value) {
                      handleStateChange(item.id, index, value.statesId);
                    } else {
                      setCityArrMap((prev) => ({ ...prev, [item.id]: [] }));
                    }
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.statesId}>
                      {option.stateName}
                    </li>
                  )}
                  sx={{ mb: 1 }}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRelWrkn[${index}].curAddCity`}
                  placeholder="Select city"
                  label={
                    <div>
                      City
                      {(cityArrMap[item.id]?.length > 0) && (
                        <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      )}
                    </div>
                  }
                  options={cityArrMap[item.id] || []}
                  getOptionLabel={(option) => option.cityName}
                  onChange={(event, value) => {
                    setValue(`empRelWrkn[${index}].curAddCity`, value, { shouldValidate: true });
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.cityId}>
                      {option.cityName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRelWrkn[${index}].refdesig`}
                  placeholder="Select Designation"
                  label={
                    <div>
                      Designation<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={desgRefData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
            </Box>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index, item.id)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmpRelwrknwithusNewEditForm.propTypes = {
  relshnData: PropTypes.array,
  countryArr: PropTypes.array,
  desgRefData: PropTypes.array,
};
